var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarDecoration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91.56,
    height: 91.56,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.0764 57.9519L67.6063 76.4237L47.5627 51.2837L39.7691 81.4691L16.9173 72.1625L32.7473 45.6635L0.979668 47.0643L3.23646 24.1176L34.1225 31.6803L23.7406 2.78447L47.9676 -1.89205L49.7313 29.2333L74.2886 8.47983L86.8445 29.8063L57.8592 41.074L84.0764 57.9519Z",
    fill: "#F5770D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDecoration);
export default __webpack_public_path__ + "static/media/star-decoration.ad6bdebdac03b8964b1e95ac6d685c23.svg";
export { ForwardRef as ReactComponent };